import React from 'react';
import { Segmented } from '../../../Controls/Segmented';
import { useFilterField } from '../../hooks/useFilterField';
import { useFilterBarContext } from '../../state/FilterBarContext';
import type { SegmentToggleFilterConfig } from '../../types';

export interface SegmentToggleFilterControlProps {
  name: string;
}

export const SegmentToggleFilterControl: React.FC<SegmentToggleFilterControlProps> = ({ name }) => {
  const { value, setValue, config, options } = useFilterField(name);
  const { size } = useFilterBarContext();

  if (!config || config.type !== 'SEGMENT_TOGGLE') {
    return null;
  }

  const st = config as SegmentToggleFilterConfig<string | number>;

  // Options come from state (loaded via dataSource — static or async) so this
  // control treats them uniformly with SELECT.
  const segmentOptions = options.map((o) => ({
    value: o.value as string | number,
    label: String(o.label ?? o.value),
    disabled: o.disabled,
  }));

  return (
    <Segmented
      {...st.controlProps}
      options={segmentOptions}
      value={value as string | number}
      onChange={(v) => setValue(v)}
      size={st.size ?? size}
    />
  );
};
